// Appointment status configurations and utilities

export const STATUS_OPTIONS = [
	{ value: 'booked', label: 'Booked', color: '#2e7d32' },
	{ value: 'bookPending', label: 'Book Pending', color: '#ed6c02' },
	{ value: 'completed', label: 'Completed', color: '#1976d2' },
	{ value: 'noShow', label: 'No Show', color: '#d32f2f' },
	{ value: 'cancelled', label: 'Cancelled', color: '#d32f2f' }
]

export const getStatusColor = (status) => {
	switch (status) {
		case 'booked': return 'success'
		case 'bookPending': return 'warning'
		case 'completed': return 'info'
		case 'noShow': return 'error'
		case 'cancelled': return 'error'
		default: return 'default'
	}
}

export const getStatusLabel = (status) => {
	switch (status) {
		case 'booked': return 'Booked'
		case 'bookPending': return 'Book Pending'
		case 'completed': return 'Completed'
		case 'noShow': return 'No Show'
		case 'cancelled': return 'Cancelled'
		default: return status
	}
}

export const getStatusOption = (status) => {
	return STATUS_OPTIONS.find(option => option.value === status) || STATUS_OPTIONS[0]
}
